import { render } from "./CreateParts.vue?vue&type=template&id=e430e5ba&scoped=true"
import script from "./CreateParts.vue?vue&type=script&lang=js"
export * from "./CreateParts.vue?vue&type=script&lang=js"

import "./CreateParts.vue?vue&type=style&index=0&id=e430e5ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e430e5ba"]])

export default __exports__